import { styled } from '@/styled-system/jsx';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link, {
  variants: {
    isActive: {
      true: {
        color: 'blue.400',
      },
      false: {
        color: 'text.subtle',
      },
    },
  },
});
